import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppContextService } from '../../services/app-context.service';
import {
	SchedulerCronJobExecutionRequest,
	SchedulerCronJobsSearchCountCriteria,
	SchedulerCronJobsSearchCriteria,
	SchedulerCronJobsSearchResult,
} from './scheduler-api.models';
import { OperationResult } from '../../models/server-result/operation-result';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SchedulerApiService {
	constructor(
		private http: HttpClient,
		private appContext: AppContextService,
		private domSanitizer: DomSanitizer
	) {}

	public searchSchedulerCronJobs(criteria: SchedulerCronJobsSearchCriteria): Observable<OperationResult<SchedulerCronJobsSearchResult[]>> {
		return this.http.post<OperationResult<SchedulerCronJobsSearchResult[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/scheduler/cronjobs/aggregates/search')!,
			criteria
		);
	}

	public countSearchSchedulerCronJobs(criteria: SchedulerCronJobsSearchCountCriteria): Observable<OperationResult<number>> {
		return this.http.post<OperationResult<number>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/scheduler/cronjobs/aggregates/searchCount')!,
			criteria
		);
	}

	public triggerSchedulerCronJobs(request: SchedulerCronJobExecutionRequest): Observable<OperationResult<boolean>> {
		return this.http.post<OperationResult<boolean>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/scheduler/cronjobs/requestExecution')!,
			request
		);
	}
}
